var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2D3D5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5322 14.0938C13.8447 12.7812 16.001 12.7812 17.3135 14.0938C18.4854 15.2656 18.6494 17.1172 17.6885 18.4766L17.665 18.5C17.4307 18.8516 16.9619 18.9219 16.6104 18.6875C16.2822 18.4297 16.1885 17.9609 16.4463 17.6328L16.4697 17.6094C17.0088 16.8359 16.915 15.8281 16.2588 15.1719C15.5322 14.4219 14.3369 14.4219 13.5869 15.1719L10.9619 17.7969C10.2119 18.5234 10.2119 19.7188 10.9619 20.4688C11.6182 21.125 12.6494 21.1953 13.3994 20.6797L13.4229 20.6328C13.7744 20.3984 14.2432 20.4688 14.4775 20.8203C14.7119 21.1484 14.6416 21.6172 14.3135 21.875L14.2666 21.8984C12.9072 22.8594 11.0791 22.6953 9.90723 21.5234C8.57129 20.2109 8.57129 18.0547 9.90723 16.7422L12.5322 14.0938ZM19.4463 19.9062C18.1338 21.2422 15.9775 21.2422 14.665 19.9062C13.4932 18.7344 13.3291 16.9062 14.29 15.5469L14.3135 15.5234C14.5479 15.1719 15.0166 15.1016 15.3682 15.3359C15.6963 15.5703 15.79 16.0391 15.5322 16.3906L15.5088 16.4141C14.9697 17.1641 15.0635 18.1953 15.7197 18.8516C16.4463 19.6016 17.6416 19.6016 18.3916 18.8516L21.0166 16.2266C21.7666 15.4766 21.7666 14.2812 21.0166 13.5547C20.3604 12.8984 19.3291 12.8047 18.5791 13.3438L18.5557 13.3672C18.2041 13.625 17.7354 13.5312 17.501 13.2031C17.2666 12.875 17.3369 12.4062 17.665 12.1484L17.7119 12.125C19.0713 11.1641 20.8994 11.3281 22.0713 12.5C23.4072 13.8125 23.4072 15.9688 22.0713 17.2812L19.4463 19.9062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteHover);
export default __webpack_public_path__ + "static/media/website-hover.80fffea3b7ee380a57b4d9ffb4d16988.svg";
export { ForwardRef as ReactComponent };